import React from 'react';

import {
  StyledButton,
} from '../../coreui';

const SecondaryButton = (props) => {
  return (
    <StyledButton
      type="L4"
      {...props}
    />
  );
};

export default SecondaryButton;
